module.exports = __webpack_public_path__ + "static/media/biothings-explorer-logo.4aba2521.png";